import { render, staticRenderFns } from "./StatusChange.vue?vue&type=template&id=52d2a9c7"
import script from "./StatusChange.js?vue&type=script&lang=js&external"
export * from "./StatusChange.js?vue&type=script&lang=js&external"
import style0 from "./StatusChange.vue?vue&type=style&index=0&id=52d2a9c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports